<template>
  <div class="py-12 px-4 bg-gray-50">
    <div class="flex flex-col items-center mb-8">
      <h2 class="text-2xl font-bold mb-2">Learning</h2>
      <p class="text-gray-500 text-sm">学習コンテンツ</p>
      <div class="w-12 h-1 bg-blue-500 mt-3 rounded"></div>
    </div>

    <p class="text-center text-sm text-gray-600 max-w-xl mx-auto mb-10">
      ITエンジニアを目指す方・新技術を習得したい現役エンジニア向けに、Udemyで学習コンテンツを提供しています。<br>
      <span class="font-semibold text-gray-800">延べ4万人以上</span>の受講生に活用いただいています。
    </p>

    <div class="max-w-3xl mx-auto">
      <h3 class="text-sm font-semibold text-gray-500 uppercase tracking-widest mb-4 text-center">Udemy コース</h3>
      <div class="grid sm:grid-cols-2 grid-cols-1 gap-3 mb-10">
        <a v-for="course in courses" :key="course.title"
          :href="course.url" target="_blank"
          class="flex items-center gap-3 p-3 rounded-xl hover:shadow-md transition-shadow"
          :class="course.color">
          <img :src="course.img" :alt="course.title" class="w-14 h-14 rounded object-cover flex-shrink-0">
          <span class="text-white text-xs font-medium leading-snug">{{ course.title }}</span>
        </a>
      </div>

      <h3 class="text-sm font-semibold text-gray-500 uppercase tracking-widest mb-4 text-center">著書</h3>
      <a href="https://www.shuwasystem.co.jp/book/9784798054520.html" target="_blank"
        class="flex items-center gap-4 p-4 bg-white border border-gray-100 rounded-xl hover:shadow-md transition-shadow max-w-sm mx-auto">
        <img src="@/assets/docker-book.jpg" alt="チャレンジDocker仮想化環境構築入門" class="w-16 rounded shadow-sm flex-shrink-0">
        <div>
          <p class="text-sm font-semibold text-gray-800 leading-snug mb-1">ITエンジニアになる! チャレンジDocker仮想化環境構築入門</p>
          <p class="text-xs text-gray-400">秀和システム / 2018年8月</p>
        </div>
      </a>
    </div>

    <p class="text-center text-xs text-gray-400 mt-8">
      割引クーポンをご希望の方はお問い合わせフォームよりご連絡ください。
    </p>
  </div>
</template>

<script>
export default {
  name: 'LearningContents',
  data() {
    return {
      courses: [
        {
          title: 'ゼロからはじめる Dockerによるアプリケーション実行環境構築',
          url: 'https://www.udemy.com/course/docker-k/?referralCode=E7ED825BC859AD0E5D9D',
          img: require('@/assets/docker.jpg'),
          color: 'bg-gradient-to-r from-cyan-500 to-blue-500'
        },
        {
          title: 'フルスタックエンジニアが教える 即戦力Railsエンジニア養成講座',
          url: 'https://www.udemy.com/course/rails-kj/?referralCode=052722308EDAEEE70FA2',
          img: require('@/assets/rails.jpg'),
          color: 'bg-gradient-to-r from-red-500 to-red-700'
        },
        {
          title: 'Vue.js + Firebaseで作るシングルページアプリケーション',
          url: 'https://www.udemy.com/course/vuejs-firebase/?referralCode=54339DCB483ED8CACB40',
          img: require('@/assets/vue-firebase.jpg'),
          color: 'bg-gradient-to-r from-emerald-400 to-emerald-500'
        },
        {
          title: 'Amazon Web Service マスターコース EC2編',
          url: 'https://www.udemy.com/course/amazon-web-service-ec2/?referralCode=F5B295163B3A87844331',
          img: require('@/assets/EC2.jpg'),
          color: 'bg-gradient-to-r from-orange-400 to-orange-500'
        },
        {
          title: 'Amazon Web Service マスターコース VPC編',
          url: 'https://www.udemy.com/course/amazon-web-service-vpc/?referralCode=C5F65F3DFA0B072574ED',
          img: require('@/assets/VPC.jpg'),
          color: 'bg-gradient-to-r from-cyan-500 to-blue-500'
        },
      ]
    }
  }
}
</script>
